import '../utilities/stringUtils.js';
import '../utilities/scrollIntoViewIfNeeded.js';
import { styled, useTheme } from '@vebox/etui-system';
import '../utilities/responsive.js';
import '../utilities/isEmpty.js';
import '../utilities/format-ms.js';
import '../utilities/create-transition.js';
import { useEffect, useImperativeHandle, createElement, Fragment } from 'react';
import '../utilities/get-styleprop.js';
import '../utilities/ellipsis.js';
import '../utilities/convertFormatToDateFns.js';
import { useReducerWithMiddleware } from '../utilities/hooks.js';
import '../useDebounce/useDebounce.js';
import '../useWindowSize/useWindowSize.js';
import '../useResponsive/useResponsive.js';
import { a as _objectSpread2, b as _extends } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div } from '@vebox/etui-system-elements';
import '../Accordion/Accordion.js';
import '../Accordion/AccordionSection.js';
import '../H5/H5.js';
import '../Svg-0180d7b5.js';
import '../Icon/Icon.js';
import '@vebox/etui-icons';
import { icons } from '../Icon/icons.js';
import '../Icon/helper.js';
import '../Accordion/utils/focus.js';
import '@vebox/etui-colors';
import '../ErrorLabel/ErrorLabel.js';
import '../FormItem/FormItem.js';
import '../Input/Input.js';
import '../InputLabel/InputLabel.js';
import '../TextInput/TextInput.js';
import '../InputAddon/InputAddon.js';
import 'react-dom';
import 'react-spring/renderprops.cjs';
import Badge from '../Badge/Badge.js';
import '../ClickOutside/ClickOutside.js';
import '../Tooltip/Tooltip.js';
import Button from '../Button/Button.js';
import '../Container/Row.js';
import '../Container/config.js';
import '../Container/Col.js';
import '../Chip/Chip.js';
import 'react-day-picker';
import '../DatePicker/DatePicker.js';
import '../DatePicker/NavBar.js';
import 'date-fns';
import '../DatePicker/formatters.js';
import '../H4/H4.js';
import 'react-modal';
import '../Modal-5d30452a.js';
import '../Modal/ModalHeader.js';
import '../Modal/Modal.js';
import '../DateRangePicker/DateRangePicker.js';
import 'react-popper';
import '../DropdownMenu/DropdownMenu.js';
import '../DropdownMenu/Item.js';
import '../DropdownMenu/Divider.js';
import 'lodash.isnil';
import { getTotalNumberOfFilters } from './utils.js';
import FilterPanelContent from './FilterPanelContent.js';
import SearchField from './SearchField.js';
import './state/constants.js';
import { setFilters, saveFilters, removeValue, clearAll, dismissFilters, openDrawer, closeDrawer } from './state/actions.js';
import 'lodash.isequal';
import { reducer, getInitialState } from './state/reducer.js';
import { reducerAfterware } from './state/reducerAfterware.js';
import FilterPanelContext from './FilterPanelContext.js';
import '../SideDrawer/utils.js';
import '../SideDrawer/SideDrawer.js';
import '../Tabs/Tabs.js';
import '../Tabs/TabsList.js';
import '../Tabs/Tab.js';
import '../ScrollingMenu/defaultSettings.js';
import '../ScrollingMenu/utils/index.js';
import '../ScrollingMenu/InnerWrapper.js';
import '../ScrollingMenu/ScrollingMenu.js';
import '../ScrollingMenu/ArrowWrapper.js';
import './Group/GroupTitle.js';
import Group from './Group/Group.js';
import './SummarySection/SummarySectionChip.js';
import './SummarySection/FilterChips.js';
import './SummarySection/SummarySection.js';
import FilterDrawer from './FilterDrawer.js';
import ApplyFilterButton from './FilterControls/ApplyFilterButton.js';
import CustomControl from './FilterControls/CustomControl.js';
import '../TimePicker/constants.js';
import '../utils-1a2b02cb.js';
import '../TimePicker/Field.js';
import '../TimePicker/TimePicker.js';
import '../TimePicker/TimePickerPanel.js';
import '../TimePicker/TimeField.js';
import '../TimePicker/TimePeriodFormatField.js';
import '../styles-14c01051.js';
import DateTimeRangeControl from './FilterControls/DateTimeRangeControl/DateTimeRangeControl.js';
import 'react-select';
import '../SelectInput/Control.js';
import '../SelectInput/ValueContainer.js';
import '../SelectInput/IndicatorsContainer.js';
import '../SelectInput/DropdownIndicator.js';
import '../SelectInput/ClearIndicator.js';
import '../SelectInput/Menu.js';
import '../SelectInput/SelectInput.js';
import SelectInputControl from './FilterControls/SelectInputControl.js';
import '../NumberInput/NumberInput.js';
import RangeInputControl from './FilterControls/RangeInputControl/RangeInputControl.js';
import TextInputControl from './FilterControls/TextInputControl.js';

const FilterPanelRoot = styled(Div)`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const FilterButtonWrapper = styled(Div)`
  display: flex;
  align-items: center;
`;

const FilterPanelComponent = ({
  title = 'Filters',
  styles = {},
  buttonProps = {},
  onSearchChange,
  searchPlaceholder,
  componentLabels,
  noFiltersSummaryLabel = "You haven't chosen any filters yet",
  children,
  summaryFieldsMetadata,
  onFiltersChange,
  initialFilters = {},
  useDrawer = true,
  useTabs = true,
  showSummary = true,
  showHeader = useDrawer,
  showCancelButton = useDrawer,
  drawerProps,
  filterPanelRef,
  onIntermediateFiltersChange,
  onOpenStateChange,
  onFilterPanelInitialized
}) => {
  var _styles$button, _styles$button2, _buttonProps$iconProp, _buttonProps$iconProp2, _buttonProps$iconProp3, _buttonProps$iconProp4, _buttonProps$iconProp5, _buttonProps$iconProp6;
  const theme = useTheme();
  const [state, dispatch] = useReducerWithMiddleware({
    reducer,
    initialState: getInitialState(initialFilters),
    afterwareFns: [(filterState, action) => reducerAfterware({
      state: filterState,
      action,
      onFiltersChange,
      onIntermediateFiltersChange,
      onOpenStateChange
    })]
  });
  useEffect(() => {
    onFilterPanelInitialized === null || onFilterPanelInitialized === void 0 ? void 0 : onFilterPanelInitialized(summaryFieldsMetadata);
  }, []);
  const numberOfAppliedFilters = getTotalNumberOfFilters(state.appliedFilters);
  const showSearchField = !!onSearchChange;
  useImperativeHandle(filterPanelRef, () => ({
    setFilters: filters => {
      dispatch(setFilters(filters));
      dispatch(saveFilters());
    },
    removeFilter: (field, value) => {
      dispatch(removeValue(field, value));
      dispatch(saveFilters());
    },
    clearAllFilters: () => {
      dispatch(clearAll());
      dispatch(saveFilters());
    }
  }));
  return /*#__PURE__*/createElement(FilterPanelContext.Provider, {
    value: {
      state,
      dispatch
    }
  }, /*#__PURE__*/createElement(FilterPanelRoot, styles.root, useDrawer ? /*#__PURE__*/createElement(Fragment, null, showSearchField && /*#__PURE__*/createElement(SearchField, {
    onSearchChange: onSearchChange,
    placeholder: searchPlaceholder,
    styles: styles === null || styles === void 0 ? void 0 : styles.searchField
  }), /*#__PURE__*/createElement(FilterButtonWrapper, {
    style: _objectSpread2({}, styles === null || styles === void 0 ? void 0 : (_styles$button = styles.button) === null || _styles$button === void 0 ? void 0 : _styles$button.wrapper)
  }, numberOfAppliedFilters ? /*#__PURE__*/createElement(Badge, {
    text: numberOfAppliedFilters,
    iconOnly: true,
    isRound: true,
    styles: {
      root: _objectSpread2({
        bg: theme.palette.black[80],
        transform: 'translate(20%,-25%) scale(.9) !important'
      }, styles === null || styles === void 0 ? void 0 : (_styles$button2 = styles.button) === null || _styles$button2 === void 0 ? void 0 : _styles$button2.badge)
    }
  }, /*#__PURE__*/createElement(Button, _extends({
    testId: "filterDrawerButton",
    iconOnly: true,
    p: 0
  }, buttonProps, {
    iconProps: _objectSpread2(_objectSpread2({
      glyph: icons.FILTER,
      size: 32
    }, buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.iconProps), {}, {
      styles: _objectSpread2(_objectSpread2({}, buttonProps === null || buttonProps === void 0 ? void 0 : (_buttonProps$iconProp = buttonProps.iconProps) === null || _buttonProps$iconProp === void 0 ? void 0 : _buttonProps$iconProp.styles), {}, {
        root: _objectSpread2({
          opacity: numberOfAppliedFilters === 0 ? 0.8 : 1
        }, buttonProps === null || buttonProps === void 0 ? void 0 : (_buttonProps$iconProp2 = buttonProps.iconProps) === null || _buttonProps$iconProp2 === void 0 ? void 0 : (_buttonProps$iconProp3 = _buttonProps$iconProp2.styles) === null || _buttonProps$iconProp3 === void 0 ? void 0 : _buttonProps$iconProp3.root)
      })
    }),
    onClick: () => dispatch(state.isDrawerOpen ? dismissFilters() : openDrawer()),
    styles: styles === null || styles === void 0 ? void 0 : styles.button
  }))) : /*#__PURE__*/createElement(Button, _extends({
    testId: "filterDrawerButton",
    iconOnly: true,
    p: 0
  }, buttonProps, {
    iconProps: _objectSpread2(_objectSpread2({
      glyph: icons.FILTER,
      size: 32
    }, buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.iconProps), {}, {
      styles: _objectSpread2(_objectSpread2({}, buttonProps === null || buttonProps === void 0 ? void 0 : (_buttonProps$iconProp4 = buttonProps.iconProps) === null || _buttonProps$iconProp4 === void 0 ? void 0 : _buttonProps$iconProp4.styles), {}, {
        root: _objectSpread2({
          opacity: numberOfAppliedFilters === 0 ? 0.8 : 1
        }, buttonProps === null || buttonProps === void 0 ? void 0 : (_buttonProps$iconProp5 = buttonProps.iconProps) === null || _buttonProps$iconProp5 === void 0 ? void 0 : (_buttonProps$iconProp6 = _buttonProps$iconProp5.styles) === null || _buttonProps$iconProp6 === void 0 ? void 0 : _buttonProps$iconProp6.root)
      })
    }),
    onClick: () => dispatch(state.isDrawerOpen ? closeDrawer() : openDrawer()),
    styles: styles === null || styles === void 0 ? void 0 : styles.button
  }))), /*#__PURE__*/createElement(FilterDrawer, {
    drawerProps: drawerProps,
    title: title,
    noFiltersSummaryLabel: noFiltersSummaryLabel,
    componentLabels: componentLabels,
    summaryFieldsMetadata: summaryFieldsMetadata,
    styles: {
      drawer: styles.drawer,
      content: styles.content
    },
    useTabs: useTabs,
    showHeader: showHeader,
    showSummary: showSummary,
    showCancelButton: showCancelButton
  }, children)) : /*#__PURE__*/createElement(FilterPanelContent, {
    summaryFieldsMetadata: summaryFieldsMetadata,
    styles: styles.content,
    noFiltersSummaryLabel: noFiltersSummaryLabel,
    componentLabels: componentLabels,
    title: title,
    useTabs: useTabs,
    showHeader: showHeader,
    showSummary: showSummary,
    showCancelButton: showCancelButton
  }, children)));
};
const FilterPanel = Object.assign(FilterPanelComponent, {
  SelectInput: SelectInputControl,
  RangeInput: RangeInputControl,
  TextInput: TextInputControl,
  DateTimeRangeInput: DateTimeRangeControl,
  ApplyFilterButton,
  CustomControl,
  Group
});

export default FilterPanel;
